import { Grid } from '@material-ui/core'
import React from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import PropTypes from 'prop-types'

const styles = () => ({
  message: {
    boxShadow: '0px 3px 6px #00000029',
    border: '2px solid #F9A270',
    borderRadius: '4px',
    color: '#F9A270',
    padding: '12px',
    textAlign: 'center',
    marginTop: '10px',
    fontWeight: 500
  },
  newExperienceMessage: {
    fontFamily: 'Roboto',
    fontSize: '13px',
    fontWeight: 500,
    boxShadow: '0px 3px 6px #00000029',
    borderRadius: '4px',
    color: '#333333',
    padding: '12px',
    textAlign: 'center',
    marginTop: '10px',
    backgroundColor: '#FBE599',
    textTransform: 'uppercase',
    letterSpacing: '1.23px',
    opacity: 1,
  }
})

const OnlineSaleCommissionMessage = ({ classes, percentage, newExperience = false }) => {
  return(
    <Grid className={newExperience ? classes.newExperienceMessage : classes.message}>
      Comisión para ventas únicamente online: {percentage}
    </Grid>
  )
}

OnlineSaleCommissionMessage.propTypes = {
  percentage: PropTypes.string,
}

export default withStyles(styles)(OnlineSaleCommissionMessage)
